import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Margin } from "@mui/icons-material";
import { SchedulerProviderArray } from "../../../actions/SchedulerActions";
const SchedulerList = React.memo(({ type, ItemLists, placeHolder, className }) => {

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const listItems = useMemo(() => {
    return Array.isArray(ItemLists) ? [...ItemLists] : [];
  }, [ItemLists])

  const filteredListItem = useMemo(() => {
    return (ItemLists ?? []).filter(item => item.value !== "All");
  }, [ItemLists]);

  const [filteredItems, setFilteredItems] = useState(listItems);

  const handleSelectBarClick = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    if (item.value != -1 && item.value != 'All') {
      const isSelected = selectedItems?.some(
        (selectedItem) => selectedItem?.value === item.value
      );
      if (isSelected) {
        // setSelectedItems();
        setSelectedItems(selectedItems.length === 1 ? [] : selectedItems?.filter((selectedItem) => selectedItem?.value !== item.value));

      } else {
        setSelectedItems((prev) => [...prev, item]);
      }
    }
    if (item.value === "All") {
      if (item.display === 'Select All') {
        let filteredArray = filteredListItem?.filter((DropDownItem) => {

          if (DropDownItem.value === "All") {
            return false
          }
          else {
            let notSelectedValue = !selectedItems.some((selected) => {
              return (DropDownItem.value === selected.value);
            })
            return notSelectedValue
          }
        })

        if (filteredArray.length === 0) {
          setSelectedItems([]);
        } else {
          setSelectedItems(
            [...selectedItems, ...filteredArray]
          );
        }

      }
      else if (item.display === 'Unselect All') {
        setSelectedItems([]);
      }

    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const FilteredNonSelectedItems = (outerArray, innerArray) => {

    let filteredArray = outerArray?.filter((DropDownItem) => {

      if (DropDownItem.value === "All") {
        return false;
      }
      else {
        let notSelectedValue = !innerArray.some((selected) => {
          return (DropDownItem.value === selected.value);
        })
        return notSelectedValue;
      }

    })

    return filteredArray;

  }

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {

    const filteredItemArray = listItems?.filter((item) =>
      item?.display?.toLowerCase().includes(searchQuery?.toLowerCase()) || item?.value === "All"
    );
    setFilteredItems(filteredItemArray);

  }, [searchQuery])

  useEffect(() => {

    if (Array.isArray(filteredListItem) && filteredListItem?.length >= 1) {
      if (type === 'AppointmentType' || type === 'AppointmentStatus') {
        setSelectedItems(filteredListItem);
      }
      else {
        const firstItem = filteredListItem[0]
        if (!selectedItems.some(item => item.value === firstItem.value)) {
          setSelectedItems([firstItem]);
        }
      }
    }
  }, [])

  useEffect(() => {

    if (["Location", "AppointmentStatus", "AppointmentType"].includes(type)) {
      dispatch(SchedulerProviderArray({ type: `Selected${type}Array`, payload: selectedItems }));

      setFilteredItems((prev) => {
        let filteredArray = FilteredNonSelectedItems(filteredListItem, selectedItems);
        let updatedArray = [...prev];

        if (filteredArray.length === 0) {
          updatedArray[0] = { value: "All", display: "Unselect All" };
        } else {
          updatedArray[0] = { value: "All", display: "Select All" };
        }

        return JSON.stringify(prev) !== JSON.stringify(updatedArray) ? updatedArray : prev;
      });

    }

  }, [selectedItems])

  return (
    <div className={`hk-SchedulerList ${className}`}>
      {(type === 'AppointmentStatus' || type === 'AppointmentType' || type === 'Location') ?
        <></>
        :
        <div
          className="hk-SchedulerList__selectBar"
          onClick={handleSelectBarClick}
        >
          <input
            type="text"
            placeholder={placeHolder}
            value={selectedItems.map((item) => item?.display).join(", ")}
          />
          <i className={`icon-caret-${isOpen ? "up" : "down"}`}></i>
        </div>}

      <div className="hk-SchedulerList__body">

        <div className='ar-input position-relative mb-06-px'>
          <input
            type="text"
            className="form-control w-100 border-0 rounded-0"
            name="AllocateAmount"
            id="AllocateAmount"
            variant="outlined"
            placeholder='Search...'
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <i className='icon-Clip-path-group fs-10 position-absolute translate-middle-y top-50'></i>
        </div>

        {(type === 'AppointmentStatus' || type === 'AppointmentType' || type === 'Location') ?
          <>
            <div className="hk-SchedulerList__body__list">
              {filteredItems?.map((item) => (
                <div
                  key={item?.value}
                  className={`hk-SchedulerList__body__list__item ${selectedItems?.some(
                    (selectedItem) => selectedItem?.value === item?.value
                  )
                    ? "selected"
                    : ""
                    }`}
                // onClick={() => handleItemClick(item)}
                >
                  {selectedItems.some(
                    (selectedItem) => selectedItem?.value === item?.value
                  ) && <i className="icon-check"></i>}
                  {(type === 'Location' || type === 'AppointmentStatus') ?
                    <div className="d-flex w-100 align-items-center justify-content-between">
                      <span className={`w-75 ${item.value === "All" ? 'font-m fs-11 text-uppercase user-select-none sticky-select' : ''}`} onClick={() => handleItemClick(item)}>{item?.display}</span>
                      {item?.value !== "All" && (type === 'Location' ?
                        <span className='loca'>
                          {/* {console.log("LocationColorCode", item?.LocationColorCode)} */}
                          <i className={`icon-location-v1 ${item?.LocationColorCode}`} style={{ color: `${item?.LocationColorCode}` }}><i className="path1"></i><i className="path2"></i><i className="path3"></i></i>
                        </span>
                        :
                        <div class={`ar_chekbox-circle  ${item?.ColorCode}`} style={{ backgroundColor: `${item?.ColorCode}`, margin: '0' }}></div>)
                      }
                    </div> : <span className={`${item.value === "All" ? 'font-m fs-11 text-uppercase user-select-none sticky-select' : ''}`} onClick={() => handleItemClick(item)}>{item?.display}</span>}

                  {/* <div className="d-flex w-100 align-items-center justify-content-between">
                  <span className="w-75" onClick={() => handleItemClick(item)}>{item?.display} </span>
                  <span><span className='Rapchik'><span className={`icon-location-v1 ${item?.LocationColorCode}`} style={{ color: `${item?.LocationColorCode}` }}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span></span></span>
                </div> */}
                </div>
              ))}
            </div>
          </> : isOpen && <>
            <div className="hk-SchedulerList__body__searchBar">
              <i className="bi bi-search"></i>
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
            <div className="hk-SchedulerList__body__list">
              {filteredItems?.map((item) => (
                <div
                  key={item?.value}
                  className={`hk-SchedulerList__body__list__item ${selectedItems?.some(
                    (selectedItem) => selectedItem?.value === item?.value
                  )
                    ? "selected"
                    : ""
                    }`}
                  onClick={() => handleItemClick(item)}
                >
                  {selectedItems.some(
                    (selectedItem) => selectedItem?.value === item?.value
                  ) && <i className="icon-check"></i>}
                  <span >{item?.display}</span>
                </div>
              ))}
            </div>
          </>}

      </div>
    </div>
  );
});

export default SchedulerList;
